<template>
    <section class="projects-section">
        <div class="section-container">
            <h2 class="section-title">深耕多媒体领域 · 打造高质量案例</h2>
            <div class="divider"></div>
            <div class="tabs">
                <button v-for="(tab, index) in tabs" :key="index"
                        :class="['tab-button', { active: activeTab === index }]"
                        @click="changeTab(index)">
                    {{ tab }}
                    <svg v-if="activeTab === index" class="underline" width="100%" height="4" viewBox="0 0 100 4"
                         preserveAspectRatio="none">
                        <path d="M0,2 L100,2" stroke="url(#gradient)" stroke-dasharray="5,3" stroke-width="2" fill="none" />
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#4a90e2" />
                                <stop offset="100%" stop-color="#50e3c2" />
                            </linearGradient>
                        </defs>
                    </svg>
                </button>
            </div>

            <div class="projects-grid">
                <div v-for="(project, index) in paginatedProjects" :key="index"
                     class="project-item" @click="handleProjectClick(project)">
                    <div class="project-thumbnail">
                        <img :src="project.image" :alt="project.title" class="thumbnail-img">
                        <div class="thumbnail-overlay">
                            <h3 class="project-title">{{ project.title }}</h3>
                            <div v-if="project.hasVideo" class="play-icon">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="2" />
                                    <path d="M10 8L16 12L10 16V8Z" fill="white" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 视频播放模态框 -->
            <div v-if="showVideoModal" class="video-modal" @click.self="closeVideoModal">
                <div class="modal-content">
                    <button class="close-button" @click="closeVideoModal">×</button>
                    <video v-if="currentVideo" controls autoplay class="video-player" ref="videoPlayer">
                        <source :src="currentVideo" type="video/mp4">
                        您的浏览器不支持视频播放。
                    </video>
                </div>
            </div>

            <div class="pagination">
                <button class="arrow-button left-arrow" @click="prevPage" :disabled="currentPage == 1">←</button>
                <div class="page-numbers">
                    <button v-for="page in totalPages" :key="page"
                            :class="['page-button', { active: currentPage === page }]"
                            @click="goToPage(page)">
                        {{ page }}
                    </button>
                </div>
                <button class="arrow-button right-arrow" @click="nextPage" :disabled="currentPage === totalPages">→</button>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'ProjectsSection',
        data() {
            return {
                tabs: ['文博展馆', '企业展示', '教育科普', '文旅商业', '数字内容'],
                activeTab: 0,
                currentPage: 1,
                windowWidth: window.innerWidth,
                showVideoModal: false,
                currentVideo: null,
                projects: [
                    // 文博展馆
                    [
                        {
                            image: require('../assets/materials/projects/museum/museum1.jpg'),
                            title: '江西瑞金中央革命根据地历史博物馆',
                            videoPath: 'museum/museum1.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum2.jpg'),
                            title: '杭州孝道文化体验馆',
                            videoPath: 'museum/museum2.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum3.jpg'),
                            title: '吉安市文化展示中心',
                            videoPath: 'museum/museum3.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum4.jpg'),
                            title: '江西省博物馆生态展',
                            videoPath: 'museum/museum4.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum5.jpg'),
                            title: '抚州市临川区博物馆',
                            videoPath: 'museum/museum5.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum6.jpg'),
                            title: '龙南客家传统文化展示中心',
                            videoPath: 'museum/museum6.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum7.jpg'),
                            title: '南方红军三年游击战争纪念馆',
                            videoPath: 'museum/museum7.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum8.jpg'),
                            title: '嵊泗博物馆',
                            videoPath: 'museum/museum8.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum9.jpg'),
                            title: '汤显祖纪念馆',
                            videoPath: 'museum/museum9.mp4',
                            hasVideo: false
                        }, {
                            image: require('../assets/materials/projects/museum/museum10.jpg'),
                            title: '婺源博物馆',
                            videoPath: 'museum/museum10.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum11.jpg'),
                            title: '宁都县小布红军总后方医院旧址',
                            videoPath: 'museum/museum11.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/museum/museum12.jpg'),
                            title: '中国杏林中医药文化展示馆',
                            videoPath: 'museum/museum12.mp4',
                            hasVideo: false
                        }
                    ],
                    // 企业展示
                    [
                        {
                            image: require('../assets/materials/projects/company/company9.jpg'),
                            title: '闵行西门子展厅',
                            videoPath: 'company/company9.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/company/company7.jpg'),
                            title: '苏州西门子展厅',
                            videoPath: 'company/company7.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/company/company8.jpg'),
                            title: '扬州西门子展厅',
                            videoPath: 'company/company8.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/company/company1.jpg'),
                            title: '北京食品营养与健康高精尖创新中心数智化展示空间',
                            videoPath: 'company/company1.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/company/company6.jpg'),
                            title: '上海英飞凌总部展厅',
                            videoPath: 'company/company6.mp4',
                            hasVideo: false
                        },
                      
                        {
                            image: require('../assets/materials/projects/company/company3.jpg'),
                            title: '昆山利乐工厂展厅',
                            videoPath: 'company/company3.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/company/company4.jpg'),
                            title: '美敦力上海进博会',
                            videoPath: 'company/company4.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/company/company5.jpg'),
                            title: '浙江起步股份展厅',
                            videoPath: 'company/company5.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/company/company2.jpg'),
                            title: '上海金桥临港展厅',
                            videoPath: 'company/company2.mp4',
                            hasVideo: false
                        }
                     
                      
                    ],
                    // 教育科普
                    [
                        {
                            image: require('../assets/materials/projects/education/education1.jpg'),
                            title: '建德市明镜小学德文化展示馆',
                            videoPath: 'education/education1.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/education/education2.jpg'),
                            title: '临安市衣锦小学家风传承展示馆',
                            videoPath: 'education/education2.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/education/education3.jpg'),
                            title: '青田县江南小学人防体验馆',
                            videoPath: 'education/education3.mp4',
                            hasVideo: false
                        }
                      /*  {
                            image: require('../assets/materials/projects/education/education4.jpg'),
                            title: '青田县水南社区',
                            videoPath: 'education/education4.mp4',
                            hasVideo: false
                        }*/
                    
                    ],
                    // 文旅商业
                    [
                        {
                            image: require('../assets/materials/projects/tourism/tourism1.jpg'),
                            title: '湖州长颈鹿庄园展陈科普馆',
                            videoPath: 'tourism/tourism1.mp4',
                            hasVideo: false
                        },
                        {
                            image: require('../assets/materials/projects/tourism/tourism2.jpg'),
                            title: '建德市乌石村廉文化展示馆',
                            videoPath: 'tourism/tourism2.mp4',
                            hasVideo: false
                        }
                        
                    ],
                    // 数字内容
                    [
                        {
                            image: require('../assets/materials/projects/digital/digital1.jpg'),
                            title: 'AI人脸融合',
                            videoPath: 'digital/digital1.mp4',
                            hasVideo: true
                        },
                        {
                            image: require('../assets/materials/projects/digital/digital2.jpg'),
                            title: '2D影片',
                            videoPath: 'digital/digital2.mp4',
                            hasVideo: true
                        },
                        {
                            image: require('../assets/materials/projects/digital/digital3.jpg'),
                            title: '沉浸式影片',
                            videoPath: 'digital/digital3.mp4',
                            hasVideo: true
                        },
                        {
                            image: require('../assets/materials/projects/digital/digital4.jpg'),
                            title: '3D影片',
                            videoPath: 'digital/digital4.mp4',
                            hasVideo: true
                        },
                        {
                            image: require('../assets/materials/projects/digital/digital5.jpg'),
                            title: '数智人',
                            videoPath: 'digital/digital5.mp4',
                            hasVideo: true
                        },
                        {
                            image: require('../assets/materials/projects/digital/digital6.jpg'),
                            title: '杏林博物馆',
                            videoPath: 'digital/digital6.mp4',
                            hasVideo: true
                        }
                     
                    ]
                ]
            }
        },
        computed: {
            itemsPerPage() {
                return this.windowWidth < 992 ? 4 : 6;
            },
            totalPages() {
                const totalItems = this.projects[this.activeTab].length;
                return Math.ceil(totalItems / this.itemsPerPage);
            },
            paginatedProjects() {
                const startIndex = (this.currentPage - 1) * this.itemsPerPage;
                const endIndex = startIndex + this.itemsPerPage;
                return this.projects[this.activeTab].slice(startIndex, endIndex);
            }
        },
        methods: {
            changeTab(index) {
                this.activeTab = index;
                this.currentPage = 1;
            },
            goToPage(page) {
                this.currentPage = page;
            },
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                }
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                }
            },
            handleResize() {
                this.windowWidth = window.innerWidth;
                if (this.currentPage > this.totalPages) {
                    this.currentPage = this.totalPages > 0 ? this.totalPages : 1;
                }
            },
            async handleProjectClick(project) {
                if (project.hasVideo && project.videoPath) {
                    try {
                        // 动态加载视频文件
                        const videoModule = await import(`../assets/materials/projects/${project.videoPath}`);
                        this.currentVideo = videoModule.default;
                        this.showVideoModal = true;

                        // 模态框显示后自动播放视频
                        this.$nextTick(() => {
                            if (this.$refs.videoPlayer) {
                                this.$refs.videoPlayer.play();
                            }
                        });
                    } catch (error) {
                        console.error('视频加载失败:', error);
                        // 可以在这里添加用户提示，例如使用Toast或Alert
                        alert('抱歉，视频加载失败，请稍后再试');
                    }
                }
            },
            closeVideoModal() {
                this.showVideoModal = false;
                this.currentVideo = null;
                // 停止视频播放
                if (this.$refs.videoPlayer) {
                    this.$refs.videoPlayer.pause();
                    this.$refs.videoPlayer.currentTime = 0;
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        }
    }
</script>

<style scoped>
    .projects-section {
        min-height: 100vh;
        padding: 80px 20px 40px;
        background-color: white;
    }

    .section-container {
        max-width: 1200px;
        margin: 0 auto;
    }

    .section-title {
        font-size: 32px;
        text-align: center;
        margin-bottom: 20px;
        color: #333;
        font-weight: 600;
    }

    .divider {
        height: 1px;
        background: linear-gradient(to right, transparent, #ccc, transparent);
        margin: 20px 0;
    }

    .tabs {
        display: flex;
        justify-content: center;
        margin-bottom: 40px;
        gap: 30px;
        flex-wrap: wrap;
    }

    .tab-button {
        position: relative;
        background: none;
        border: none;
        font-size: 20px;
        color: #999;
        cursor: pointer;
        padding: 10px 0;
        transition: color 0.3s ease;
        font-weight: 500;
    }

        .tab-button:hover {
            color: #333;
        }

        .tab-button.active {
            color: #333;
            font-weight: 600;
        }

    .underline {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .projects-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        margin-bottom: 40px;
    }

    .project-item {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        position: relative;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        cursor: pointer;
    }

        .project-item:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
        }

    .project-thumbnail {
        position: relative;
        padding-top: 75%; /* 4:3 比例 */
        overflow: hidden;
    }

    .thumbnail-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
    }

    .thumbnail-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        transition: opacity 0.3s ease;
        padding: 20px;
        box-sizing: border-box;
    }

    .project-item:hover .thumbnail-overlay {
        opacity: 1;
    }

    .project-item:hover .thumbnail-img {
        transform: scale(1.05);
    }

    .project-title {
        color: white;
        font-size: 20px;
        text-align: center;
        margin: 0;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }

    .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 30px;
    }

    .arrow-button {
        background: none;
        border: 1px solid #ddd;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s ease;
        color: #666;
    }

        .arrow-button:hover {
            background-color: #f0f0f0;
            border-color: #999;
        }

        .arrow-button:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

    .page-numbers {
        display: flex;
        gap: 10px;
    }

    .page-button {
        width: 40px;
        height: 40px;
        border: 1px solid #ddd;
        background: none;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s ease;
        color: #666;
    }

        .page-button:hover {
            border-color: #999;
        }

        .page-button.active {
            background-color: #4a90e2;
            border-color: #4a90e2;
            color: white;
        }

    /* 视频模态框样式 */
    .video-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    .modal-content {
        position: relative;
        width: 80%;
        max-width: 800px;
        background: #000;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    }

    .video-player {
        width: 100%;
        max-height: 80vh;
        display: block;
    }

    .close-button {
        position: absolute;
        top: -40px;
        right: 0;
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        cursor: pointer;
        transition: color 0.3s ease;
    }

        .close-button:hover {
            color: #ccc;
        }

    .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0.8;
        transition: all 0.3s ease;
    }

    .project-item:hover .play-icon {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.1);
    }

    /* 响应式设计 */
    @media (max-width: 992px) {
        .section-title {
            font-size: 24px;
        }

        .tabs {
            gap: 20px;
        }

        .tab-button {
            font-size: 16px;
        }

        .projects-grid {
            grid-template-columns: repeat(2, 1fr);
        }

        .pagination {
            gap: 10px;
        }

        .arrow-button,
        .page-button {
            width: 36px;
            height: 36px;
        }
    }

    @media (max-width: 768px) {
        .section-title {
            font-size: 20px;
        }

        .tabs {
            gap: 10px;
        }

        .tab-button {
            font-size: 14px;
            padding: 8px 10px;
        }

        .projects-grid {
            grid-template-columns: 1fr;
        }

        .project-title {
            font-size: 16px;
        }

        .pagination {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;
        }

        .arrow-button {
            order: -1;
            align-self: center;
        }

        .page-numbers {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 5px;
            order: 0;
        }

        .right-arrow {
            order: 1;
        }

        .arrow-button,
        .page-button {
            width: 32px;
            height: 32px;
            font-size: 14px;
        }

        .modal-content {
            width: 95%;
        }
    }
</style>